import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "picture-slider-left",
  "use": "picture-slider-left-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"picture-slider-left\">\n    <path d=\"M.5 12A1.5 1.5 0 0 0 2 13.5h9.017a1.5 1.5 0 0 0 1.286-.728l3.003-5a1.5 1.5 0 0 0 0-1.544l-3.003-5A1.5 1.5 0 0 0 11.017.5H2A1.5 1.5 0 0 0 .5 2v10z\" fill=\"currentColor\" stroke=\"currentColor\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol